import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';

export interface FieldEditFormErrorMessages {
  required?: string;
  pattern?: string;
}

@Component({
  selector: 'app-field-edit-form',
  templateUrl: './field-edit-form.component.html',
})
export class FieldEditFormComponent implements OnChanges {
  @Input() title!: string;
  @Input() description?: string;
  @Input() label!: string;
  @Input() initialValue: string = '';
  @Input() required: boolean = true;
  @Input() inputType: string = 'text';
  @Input() validators: ValidatorFn[] = [];
  @Input() errorMessages: FieldEditFormErrorMessages = {};
  @Input() isLoading: boolean = false;

  @Output() submitted = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<void>();

  form: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({ value: [''] });
  }

  ngOnChanges(): void {
    const validators = this.required ? [Validators.required, ...this.validators] : this.validators;
    this.form.setControl('value', this.formBuilder.control(this.initialValue, validators));
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.submitted.emit((this.form.get('value')!.value as string).trim());
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
